/* eslint-disable no-unused-vars */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import App from './App';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

const vm = new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js